<template>
  <div class="topFilters mt-5">
    <div class="counter">
      {{ tableModel.bind.loading ? $t('Загрузка данных...') : formatCounter(tableModel.bind.totalEntries) }}
    </div>

    <div
      class="sortMenu"
      v-bind:class="{ sortMenuDisabled: tableModel.bind.totalEntries === 0 }"
    >
      <v-menu
        transition="slide-x-transition"
        :disabled="tableModel.bind.totalEntries === 0"
        location="bottom left"
      >
        <template v-slot:activator="{ props }">
          <v-btn :ripple="false" v-bind="props" elevation="0" icon>
            <span class="currentSort">{{ $t(sort.current.title) }}</span>
            <v-icon class="chevronDown">{{ sort.icon }}</v-icon>
          </v-btn>
        </template>

        <v-list class="sortList">
          <v-list-item
            v-for="(sortItem, index) in sort.items"
            :key="index"
            @click="changeSort(sortItem)"
            :prepend-icon="sortItem.icon"
            :append-icon="
              sortItem.title === sort.current.title ? 'mdi-check' : ''
            "
          >
            <v-list-item-title class="sortItemTitle ml-5">
              {{ $t(sortItem.title) }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { splitNumber, formatCases } from '@/filters';
export default {
  name: 'EntityFilter',
  filters: {
    splitNumber: splitNumber,
    formatCases: formatCases,
  },
  props: {
    tableModel: {
      Object,
      required: true,
    },
    sort: {
      Object,
      required: true,
    },
  },
  methods: {
    changeSort(sortItem) {
      this.sort.current = sortItem;
      let options = {
        sortBy: [
          { key: sortItem.field, order: sortItem.order }
        ],
      };
      this.tableModel.reload(options);
    },
    formatCounter(v) {
      let cases = {
        nom: 'процедура',
        gen: 'процедуры',
        plu: 'процедур',
      };
      return splitNumber(v) + ' ' + formatCases(v, cases);
    },
  },
};
</script>

<style lang="scss" scoped>
.topFilters {
  display: flex;
  justify-content: space-between;
  align-self: stretch;
  padding-left: 12px;
  align-items: flex-end;

  .counter {
    color: rgba(0, 0, 0, 0.6);
    font-family: var(--primary-font-family-name);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .sortMenu button {
    padding: 5px 10px;

    background: transparent !important;
    --v-theme-overlay-multiplier: 0 !important;
    width: auto;
    height: auto;

    .v-btn__content {
      display: flex;
      align-items: center;
      gap: 5px;

      .currentSort {
        color: rgba(0, 0, 0, 0.8);
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: normal;
      }

      .chevronDown {
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }

  .sortMenu.sortMenuDisabled button {
    border: 1px solid #667085;
    background: #f8f8f8;
  }

  .sortMenu.sortMenuDisabled button .v-btn__content .currentSort,
  .sortMenu.sortMenuDisabled button .v-btn__content .chevronDown {
    color: rgba(0, 0, 0, 0.4);
  }

  .sortMenu button:focus:before {
    background-color: transparent;
  }

  .sortMenu button:hover:before {
    opacity: 0;
  }
}

div:has(> .sortList) {
  margin-top: 5px;
}

:deep(.v-icon) {
  color: rgba(0, 0, 0, 1);
}

.sortList {
  display: flex;
  padding: 10px 5px;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  box-shadow: 0px 1px 5.2px 0px rgba(0, 0, 0, 0.4) !important;
  max-width: 413px;

  .v-list-item {
    grid-template-columns: 27px 1fr auto !important;
    min-height: auto;
    display: grid;
    padding: 5px 10px;

    .sortItemTitle {
      color: rgba(0, 0, 0, 1);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
}
</style>
